import Lightbox from 'bs5-lightbox';

const options = {
	keyboard: true,
	size: 'fullscreen'
};

document.querySelectorAll('.lightbox-toggle').forEach((el) => el.addEventListener('click', (e) => {
	e.preventDefault();
	const lightbox = new Lightbox(el, options);
	lightbox.show();
}));
//
// import Swiper JS
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
// import Swiper styles
//import 'swiper/css';

const swiper = new Swiper('.swiper', {
    // Optional parameters
    //direction: 'vertical',
	modules: [Autoplay],
    loop: true,
	slidesPerView: 1,
	breakpoints: {
		768:{
			slidesPerView: 2,
		},
		992:{
			slidesPerView: 3,
		},
		1200:{
			slidesPerView: 6,
		},
	},
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 2000,
		disableOnInteraction: false, // Autoplay continues even if the user interacts with the slider
	},
});
//
jQuery(document).ready(function($) {
	$('.close').on('click', function() {
		sessionStorage.setItem('popupClosed', 'true'); // Set a sessionStorage item
		$('.footer-alert').css('display','none');
	});
	//
	// Function to check if the popup should be shown
    function checkPopup() {
        if (!sessionStorage.getItem('popupClosed')) {
            $('.footer-alert').css('display','block');
        }
    }
	//
	// Call checkPopup function when the document is ready
    checkPopup();
});